import { Progress, Tooltip } from "@mantine/core";
import "./ClientProgressBar.scss";

interface ClientProgressBarProps {
  value: number;
  tooltip: string;
}
const ClientProgressBar = ({ value, tooltip }: ClientProgressBarProps) => {
  return (
    <div className="completed-bar">
      <p className="completed-text">Completed</p>
      <Progress.Root size={25}>
        <Tooltip withArrow label={tooltip}>
          <Progress.Section value={value} color="green">
            <Progress.Label></Progress.Label>
          </Progress.Section>
        </Tooltip>
      </Progress.Root>
    </div>
  );
};

export default ClientProgressBar;
